export const extractDigitsFromString = (value: string) => {
  const onlyNumber = value.replace(/[^0-9]/g, '')
  return onlyNumber.startsWith('55') ? onlyNumber.slice(2) : onlyNumber
}

export const postBroadcastMessage = (name: string, message?: any) => {
  const broadcastChannel = new BroadcastChannel(name)
  broadcastChannel.postMessage(message || name)
  broadcastChannel.close()
}
